import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './foodHospitality.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import foodCafeSide from '../../assets/food-cafe-side.png';
import foodMidBanner from '../../assets/food-mid-banner.png';
import { sendContactEmail } from '../../utils/emailjs';

const FoodHospitality = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Food & Hospitality Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__food-page">
      <section className="kw__food-top kw__food-section">
        <p className="kw__food-outline">Food &amp; Hospitality</p>
        <div className="kw__food-hero-copy">
          <h1>Crafting Culinary Brands, Scaling Exceptional Experiences</h1>
          <p>
            Food service relies on the perfect blend of culinary passion and disciplined operational scale. We build, acquire, and manage
            high-performance restaurant concepts and food brands that resonate with modern consumers. By combining exceptional culinary execution
            with robust supply chain management and standardized operations, we transform dining spaces into highly profitable, memorable consumer
            destinations.
          </p>
        </div>
      </section>

      <section className="kw__food-dark-split">
        <div className="kw__food-section kw__food-split-inner">
          <div className="kw__food-split-copy">
            <h2>Operational Efficiency Managed From Kitchen to Table</h2>
            <p>
              We master the high-pressure complexities of the modern food and beverage (F&amp;B) industry. Maintaining strict quality assurance (QA),
              supply chain efficiency, workforce optimization, and consistency across multiple locations requires disciplined corporate management.
              Our structured operations ensure flawless day-to-day execution, safeguarding brand reputation and driving consistent demand and
              operational throughput.
            </p>
          </div>
          <img src={foodCafeSide} alt="" className="kw__food-split-image" aria-hidden="true" />
        </div>
      </section>

      <section className="kw__food-growth kw__food-section">
        <h2>Driving Growth through Culinary Acquisitions &amp; Innovation</h2>
        <p>
          Building a successful restaurant portfolio is about more than just great food it is about strategic market placement, scalable franchise
          models, and identifying high-potential culinary concepts. Our focus remains on expanding our hospitality footprint while maintaining
          absolute operational stability. We deliver sustained revenue growth, strict food safety compliance, and long-term brand equity across
          diverse dining segments. This commercial platform is purpose-built for joint-venture partners, investors, and hospitality professionals who
          understand that food businesses scale successfully only when strong back-end operations remain reliable under sustained market pressure.
        </p>
      </section>

      <section className="kw__food-mid-banner-wrap" aria-hidden="true">
        <img src={foodMidBanner} alt="" className="kw__food-mid-banner" />
      </section>

      <section className="kw__food-cta">
        <div className="kw__food-section kw__food-cta-inner">
          <h2>Ready to Scale the Future of Hospitality?</h2>
          <p>
            If you are looking to partner on food business acquisitions, expand an existing culinary franchise, or become part of a fast-growing
            restaurant group, let&apos;s build something exceptional together.
          </p>
          <button type="button" className="kw__food-cta-btn" onClick={handleNavigateToInquiryForm}>
            <span>Let&apos;s Connect to Discuss</span>
            <img src={buttonArrow} alt="" />
          </button>
        </div>
      </section>

      <section className="kw__food-newsletter kw__food-section">
        <div className="kw__food-news-copy">
          <p className="kw__food-news-label">Newsletter</p>
          <h3>Never Miss an Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
            your inbox.
          </p>
        </div>

        <form className="kw__food-news-form" onSubmit={handleSubmit}>
          <div className="kw__food-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__food-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default FoodHospitality;
